import { NgModule } from "@angular/core";
import { NormalizeNameDirective } from "./normalize-name.directive";
import { EnglishInputDirective } from "./english-input.directive";
import { ExcludeThDirective } from "./exclude-th.directive";

@NgModule({
    declarations: [
        NormalizeNameDirective,
        EnglishInputDirective,
        ExcludeThDirective,
    ],
    exports: [
        NormalizeNameDirective,
        EnglishInputDirective,
        ExcludeThDirective,
    ]
})
export class DirectiveModule { }